import { JargonTranslation } from './jargonTypes'

export const esGB: JargonTranslation = {
  abnEntity: 'un Número de Registro de Empresa',
  abn: 'CRN',
  abnLowercase: 'CRN',
  abnSearchName: 'Registro Mercantil',
  abns: 'CRNs',
  abnsLowercase: 'CRNs',
  companyInduction: 'Inducción de la Empresa',
  companyInductions: 'Inducciones de la Empresa',
  defect: 'Defecto',
  defects: 'Defectos',
  drawing: 'Dibujo',
  drawings: 'Dibujos',
  favourite: 'Favorito',
  favourites: 'Favoritos',
  induct: 'Inducir',
  inducts: 'Induce',
  inducted: 'Inducido',
  inducting: 'Induciendo',
  induction: 'Inducción',
  inductions: 'Inducciones',
  itp: 'ITP',
  itps: 'ITPs',
  people: 'Personal',
  peoples: 'Personal',
  project: 'Proyecto',
  projects: 'Proyectos',
  preStart: 'Charla de Seguridad',
  preStarts: 'Charlas de Seguridad',
  projectHoursBudget: 'Presupuesto de Horas del Proyecto',
  projectHoursBudgets: 'Presupuestos de Horas del Proyecto',
  placeholderAddress: '78 High Street, London SW1A 1AA',
  placeholderProjectName: '78 High Street',
  placeholderPhoneNumber: '020 7123 4567',
  register: 'Registro',
  registers: 'Registros',
  sdsLibrary: 'Fichas COSHH',
  sdsLibraries: 'Fichas COSHH',
  signOn: 'Registro de Entrada',
  signOns: 'Registros de Entrada',
  siteInduction: 'Inducción de Obra',
  siteInductions: 'Inducciones de Obra',
  siteDiary: 'Diario de Obra',
  siteDiaries: 'Diarios de Obra',
  staff: 'Personal',
  staffs: 'Personal',
  subcontractor: 'Empresa',
  subcontractors: 'Empresas',
  swms: 'RAMS',
  swmss: 'RAMS',
  swmsFullTitle: 'Evaluación de Riesgos y Método de Trabajo',
  ticket: 'Certificación',
  tickets: 'Certificaciones',
  timesheet: 'Hoja de Tiempo',
  timesheets: 'Hojas de Tiempo',
  worker: 'Operario',
  workers: 'Operarios',
}
